import React from 'react'
import { MapRef } from 'react-map-gl'
import BlueStar from '../../../../assets/images/v4/addresses/blue_star.svg'
import {
  Center,
  City,
  defaultCoordinates,
  SetState,
} from '../../../types/AddressesGroup'
import { mapGoTo } from '../functions'
import NoCenter from './NoCenter'
import { OldPrice } from './styles'

interface CenterslistProps {
  isCorporation: boolean
  centersToShow: Center[]
  setSelectedCity: SetState<City | undefined>
  centersUnPaginated: Center[] | []
  mapRef: MapRef | null
  selectedCity: City | undefined
  defaultCoordinates: defaultCoordinates
  isBe: boolean
  hostname: string
}

const CentersList: React.FC<CenterslistProps> = ({
  isCorporation,
  mapRef,
  centersToShow,
  setSelectedCity,
  centersUnPaginated,
  selectedCity,
  defaultCoordinates,
  isBe,
  hostname,
}: CenterslistProps) => {
  const removeFilters = () => {
    setSelectedCity(undefined)
    mapGoTo(defaultCoordinates, mapRef, defaultCoordinates.zoom)
  }
  return (
    <div>
      {centersToShow?.length > 0 ? (
        <div>
          <div className="is-flex is-justify-content-space-between">
            <div className="subtitle has-text-heading is-size-10 my-3">
              {selectedCity ? selectedCity.name : 'carte'} :{' '}
              {centersUnPaginated.length} adresse
              {centersUnPaginated.length > 1 && <span>s</span>} de domiciliation
            </div>
            {selectedCity && (
              <a
                className="is-size-10 my-3 has-text-primary is-underlined is-clickable"
                onClick={removeFilters}
                href="#"
              >
                Effacer le filtre ville
              </a>
            )}
          </div>

          <div>
            {centersToShow.map((center: Center) => {
              return (
                <a
                  className="card mb-2 is-shadowless addresses-links-list"
                  key={center.id}
                  href={`/adresses/${center.slug}`}
                >
                  <div className="columns card-addresses-list">
                    <div
                      className="column is-5 p-0 center-image"
                      id="card-image"
                    >
                      {!!center.index_image?.url && (
                        <img
                          loading="lazy"
                          srcSet={
                            center.index_image.url.replace(
                              'q_auto',
                              'q_auto,w_400,h_200'
                            ) +
                            ' 450w, ' +
                            center.index_image.url.replace(
                              'q_auto',
                              'q_auto,c_fill,w_600,h_200'
                            ) +
                            ' 768w, ' +
                            center.index_image.url.replace(
                              'q_auto',
                              'q_auto,c_fill,w_600'
                            ) +
                            ' 1200w'
                          }
                          src={center.index_image.url.replace(
                            'q_auto',
                            'q_auto,w_600'
                          )}
                          alt="présentation centre"
                        />
                      )}
                      {!center.index_image?.url && (
                        <img alt="présentation centre" />
                      )}

                      {center.top_cfe && <span className="tag">TOP CFE</span>}
                    </div>
                    <div
                      className="column p-3 address-card-radius
                       is-flex is-flex-direction-column is-justify-content-space-between is-flex-grow-1"
                    >
                      <div className="is-flex is-flex-direction-column is-align-content-space-between">
                        <div
                          className="title is-size-7 has-text-weight-bold mb-0"
                          id="card-title"
                        >
                          {center.shortname}
                        </div>
                        <div className="is-size-body1 has-text-heading m-0">
                          {center.sector_name}
                        </div>
                        <div className="has-text-component m-0 is-size-10">
                          {center.full_address_to_s}
                        </div>
                      </div>
                      <div className="is-flex is-justify-content-space-between">
                        <div className="is-size-11 is-flex is-align-items-center">
                          <span>
                            <img
                              src={BlueStar}
                              alt="etoile bleue"
                              loading="lazy"
                              width="20px"
                              height="19px"
                            />{' '}
                            &#8239;
                          </span>
                          <span className="has-text-weight-bold">
                            {new Intl.NumberFormat('fr-FR', {
                              minimumFractionDigits: 2,
                            }).format(center.average_rating)}
                          </span>
                        </div>
                        <div className="is-size-10">
                          {!!center.old_price && (
                            <OldPrice>
                              {isCorporation
                                ? center.old_price
                                : center.min_old_price_auto_entrepreneur_asso}
                              €&nbsp;
                            </OldPrice>
                          )}
                          <b>
                            {isCorporation
                              ? center.price
                              : center.min_price_auto_entrepreneur_asso}
                            €&nbsp;
                          </b>
                          par mois
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              )
            })}
          </div>
        </div>
      ) : (
        <NoCenter
          removeFilters={removeFilters}
          isBe={isBe}
          hostname={hostname}
        />
      )}
    </div>
  )
}

export default CentersList
